t = require('views/internal/teacup-with-helpers')('header_back_menu_button')

module.exports = ->
  t.a '.header-btn.js-back-menu', { href: '/', 'aria-label': t.l('backToHome') }, ->
    t.span '.header-btn-icon.icon-lg.icon-board-back-to-home.light'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_back_menu_button.coffee